import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _callSuper from "@babel/runtime/helpers/callSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _templateObject;
import React from 'react';
import { ClassNames } from '@emotion/react';
import { DefaultTooltipIcon } from './DefaultTooltipIcon';
import { defaultTooltipTriggerStyles } from './Tooltip.styled';
import { TooltipBuilder } from './TooltipBuilder';
import { StyledTooltip } from './TooltipBuilder.styled';
import { registerTooltipCloseFn } from './TooltipHost';
export var Tooltip = /*#__PURE__*/function (_React$Component) {
  function Tooltip() {
    var _this;
    _classCallCheck(this, Tooltip);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Tooltip, [].concat(args));
    _defineProperty(_this, "closeTimer", void 0);
    _defineProperty(_this, "shouldClose", false);
    _defineProperty(_this, "state", {
      isOpen: false
    });
    _defineProperty(_this, "handleMouseEnter", function () {
      _this.shouldClose = false;
      _this.setState({
        isOpen: true
      });
      registerTooltipCloseFn(_this.forceClose);
    });
    _defineProperty(_this, "handleMouseLeave", function () {
      _this.shouldClose = true;
      _this.closeTimer = window.setTimeout(function () {
        if (_this.shouldClose) {
          _this.setState({
            isOpen: false
          });
        }
      }, 250);
    });
    _defineProperty(_this, "handlePopoverContentMouseEnter", function () {
      return _this.shouldClose = false;
    });
    _defineProperty(_this, "handlePopoverContentMouseLeave", function () {
      return _this.setState({
        isOpen: false
      });
    });
    _defineProperty(_this, "forceClose", function () {
      if (_this.closeTimer) {
        window.clearTimeout(_this.closeTimer);
      }
      _this.setState({
        isOpen: false
      });
    });
    return _this;
  }
  _inherits(Tooltip, _React$Component);
  return _createClass(Tooltip, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props$hoverTrig = this.props.hoverTrigger,
        hoverTrigger = _this$props$hoverTrig === void 0 ? /*#__PURE__*/React.createElement(DefaultTooltipIcon, null) : _this$props$hoverTrig;
      var isOpen = this.props.isDisabled ? false : this.state.isOpen;
      return /*#__PURE__*/React.createElement(TooltipBuilder, {
        tooltipVisible: isOpen,
        placement: this.props.placement,
        renderHoverTrigger: function renderHoverTrigger(props) {
          return /*#__PURE__*/React.createElement(ClassNames, null, function (_ref) {
            var css = _ref.css;
            return (
              /*#__PURE__*/
              // WSUI-5750
              // eslint-disable-next-line jsx-a11y/no-static-element-interactions
              React.createElement("span", {
                className: _this2.props.className || (!_this2.props.hoverTrigger ? // prettier-ignore
                css(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), defaultTooltipTriggerStyles) : undefined),
                ref: props.ref,
                onMouseEnter: _this2.handleMouseEnter,
                onMouseLeave: _this2.handleMouseLeave
              }, hoverTrigger)
            );
          });
        },
        renderTooltip: function renderTooltip(props, arrowElement) {
          return /*#__PURE__*/React.createElement(StyledTooltip, _extends({}, props, {
            onMouseEnter: _this2.handlePopoverContentMouseEnter,
            onMouseLeave: _this2.handlePopoverContentMouseLeave,
            role: undefined,
            onClick: _this2.handlePopoverContentMouseLeave
          }), _this2.props.children, arrowElement);
        }
      });
    }
  }]);
}(React.Component);